<template>
  <div class="volumeBarItem">
    <!-- <div class="left">
      <br>
      <div>
        <el-button
          type="success"
          @click="startCallVideo"
        >Start
        </el-button>
        <el-button
          type="success"
          @click="leave"
        >Leave
        </el-button>
        <el-button
          type="success"
          @click="getVolumeData"
        >Get Volume data
        </el-button>
      </div>
      <br>
      <div>
        <el-input
          placeholder="请输入previewId"
          v-model="previewId"
        >
          <template slot="prepend">Preview Id:</template>
        </el-input>
      </div>
      <br>
      <br>
      <div>
        <el-input
          placeholder="请输入slider position"
          v-model="sliderPosition"
          @change="changePosition"
        >
          <template slot="prepend">Slider Position:</template>
        </el-input>
      </div>
      <br>
      <div>
        input buffer left value:
        <br>
        {{ volumeLeftObj.val }}
      </div>
      <div>
        input buffer right value:
        <br>
        {{ volumeRightObj.val }}
      </div>
    </div> -->
    <div class="volumeBarDiv left">
      <VolumeBar
        style="float: left;margin-right: 4px"
        :val="volumeLeftObj.val"
        :peakVal="volumeLeftObj.peakVal"
        :clipSize="volumeLeftObj.clipSize"
        :width="volumeLeftObj.width"
        :height="volumeLeftObj.height"
        :showPeaks="volumeLeftObj.showPeaks"
        :newVolumePercentage="volumeLeftObj.newVolumePercentage"
      >
      </VolumeBar>
      <VolumeBar
        style="float: left"
        :val="volumeRightObj.val"
        :peakVal="volumeRightObj.peakVal"
        :clipSize="volumeRightObj.clipSize"
        :width="volumeRightObj.width"
        :height="volumeRightObj.height"
        :showPeaks="volumeRightObj.showPeaks"
        :newVolumePercentage="volumeRightObj.newVolumePercentage"
      >
      </VolumeBar>
       <el-slider
        range
        vertical
        disabled
        :marks="marks"
        :max="299"
        :min="0"
        style="float: left"
      >
      </el-slider>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import VolumeBar from './VolumeBar'

export default {
  name: 'volumeBarTest',
  components: {
    VolumeBar
  },
  props: ['audiocontextObj', 'autoplayOff'],
  data () {
    return {
      previewId: '',
      sliderPosition: 239,
      createVideoTimer: null,
      marks: { // 固定刻度
        299: '+12',
        269: '+6',
        239: ' 0',
        209: '-6',
        179: '-12',
        149: '-18',
        119: '-24',
        89: '-30',
        0: '-∞'
      },
      volumeLeftObj: { // 其中目前 其实 就val的值在改变
        val: 0,
        peakVal: 0,
        clipSize: 10,
        width: 4,
        height: 200,
        showPeaks: false,
        newVolumePercentage: 100
      },
      volumeRightObj: { // 其中目前 其实 就val的值在改变
        val: 0,
        peakVal: 0,
        clipSize: 10,
        width: 4,
        height: 200,
        showPeaks: false,
        newVolumePercentage: 100
      }
    }
  },
  created () {
    // 将webrtc信息传过来
    Bus.$on('getSrcObject', (srcObject) => {
      if (this.volumeLeftObj) {
        this.audiocontextObj.audioTrack(srcObject.mediaStream, srcObject.peerId, this.callback)
      }
      // if(this.volumeLeftObj)
    })
  },
  methods: {
    callback (volumeData) {
      // 回调函数
      /*
       * showDialog: => 是否是弹窗提示, 只会返回一次, 弹出提示框,遍历调用resumeAudioBar()
       *
       * */
      if (volumeData.showDialog) {
        // 打开提示弹窗
        this.$emit('audioDialogOpen')
      } else {
        if (!this.autoplayOff) {
          if (volumeData.outputLeft) {
            this.volumeLeftObj.val = volumeData.outputLeft
          }
          if (volumeData.outputRight) {
            this.volumeRightObj.val = volumeData.outputRight
          }
        } else {
          this.volumeLeftObj.val = 0
          this.volumeRightObj.val = 0
        }
      }
    }
  },
  beforeDestroy () {
    Bus.$off('getSrcObject')
  }
}
</script>

<style
  scoped
  lang="less"
>
.volumeBarItem {

  /* width: 70%; */
  /* margin-left: 30px; */
  padding-left: 5px;
  /* border-bottom: 1px solid #333; */
  overflow: hidden;

  .left {
    float: left;
    width: 30%;
  }

  .video {
    margin-left: 30px;
  }

  .volumeBarDiv {
    height: 100%;
    width: 50px;

    .el-slider.is-vertical {
      height: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    }

    ::v-deep .el-slider__button-wrapper,
    ::v-deep .el-slider__bar,
    ::v-deep .el-slider__stop.el-slider__marks-stop {
      display: none;
    }

    ::v-deep .el-slider.is-vertical {
      .el-slider__runway {
        background-color: transparent;
      }

      .el-slider__marks-text {
        font-size: 12px;
        left: -15px;
        color: #666;
      }
    }

    .pvw {
      ::v-deep .el-slider.is-vertical .el-slider__marks-text {
        right: -13px;
        text-align: right;
      }
    }
  }
}
</style>
